import React, { useEffect, useState, useRef } from "react";
import "./leftPane.css";
import logo from "../../assets/logo.png";
import { useLocation, Link } from "react-router-dom";
import api from "../../utils/api";
import { IoSettingsSharp } from "react-icons/io5";
import {
  MdGroup,
  MdOutlineAddBox,
  MdTune,
  MdPersonOutline,
  MdCalendarToday,
  MdDashboard,
  MdAddBox,
} from "react-icons/md";
import { TiUserAdd } from "react-icons/ti";
import { RiBarChart2Fill } from "react-icons/ri";
import { IoMdPerson } from "react-icons/io";
import { LuMicrowave } from "react-icons/lu";
import { FaGraduationCap, FaComments, FaCalendar, FaUserGraduate } from "react-icons/fa";
import { FaChartColumn, FaUsers } from "react-icons/fa6";
import {
  ChartColumnBig,
  Settings2,
  Microwave,
  BookOpenText,
  BookOpen,
} from "lucide-react";

const LeftPane = ({ isOpen }) => {
  const [filter, setFliter] = useState(0);
  const [submenu, setSubmenu] = useState(0);
  const [rolesSubmenu, setRolesSubmenu] = useState(0); // Added state for Roles submenu
  const [data, setData] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);

  const location = useLocation();
  if (location.pathname === "") {
  }

  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  const userType = localStorage.getItem("userType");

  const canAccess = (permissionKey) => {
    if (userType === "accessUser") {
      return permissions.includes(permissionKey);
    }
    return true;
  };

  useEffect(async () => {
    api
      .get("/users/profile")
      .then((response) => (response = response.data))
      .then((data) => {
        console.log(data);
        setData(data);
      });
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const iconRefs = useRef({});
  const tooltipRef = useRef(null);
  const [tooltipStyle, setTooltipStyle] = useState({});

  const handleMouseEnter = (label, ref) => {
    setHoveredItem(label);
    const icon = iconRefs.current[ref];
    if (icon) {
      const rect = icon.getBoundingClientRect();
      setTooltipStyle({
        top: rect.top + rect.height / 2,
        left: rect.right + 10,
        position: "fixed",
        transform: "translateY(-50%)",
        zIndex: 1000,
      });
    }
  };

  const renderTooltip = (label) => {
    if (!isOpen && hoveredItem === label) {
      return (
        <div className="tooltip" ref={tooltipRef} style={tooltipStyle}>
          {label}
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className={`left_pane${isOpen ? " open" : " closed"}`}
      style={{ width: isOpen ? "360px" : "100px" }}
    >
      <div
        className="logo_container"
        style={{
          marginLeft: isOpen ? "30px" : "0",
          justifyContent: isOpen ? "flex-start" : "center",
        }}
      >
        <img src={logo}></img>
        {isOpen && (
          <div>
            <p>MMHS</p>
            <p>School Dashboard</p>
          </div>
        )}
        <button
          className="hamburger_btn"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          <span className={menuOpen ? "bar active" : "bar"}></span>
          <span className={menuOpen ? "bar active" : "bar"}></span>
          <span className={menuOpen ? "bar active" : "bar"}></span>
        </button>
      </div>
      {isOpen && (
        <div className={`user_box${menuOpen ? " menu_open" : ""}`}>
          <div className="user_info">
            <h3>
              {data
                ? `${data.firstname} ${data.lastname}`
                : "Loading..."}
            </h3>
            <p>Super Admin</p>
          </div>
        </div>
      )}

      {isOpen && (
        <h4 className={`left_pane_heading${menuOpen ? " menu_open" : ""}`}>
          Main Menu
        </h4>
      )}

      <ul
        className={menuOpen ? "menu_open" : ""}
        style={{ overflowY: isOpen ? "scroll" : "auto" }}
      >
        {canAccess("dashboard") && (
          <Link to="/">
            <li
              ref={(el) => (iconRefs.current["Dashboard"] = el)}
              onMouseEnter={() => handleMouseEnter("Dashboard", "Dashboard")}
              onMouseLeave={() => setHoveredItem(null)}
              style={{ justifyContent: isOpen ? "flex-start" : "center" }}
              onClick={() => setFliter(0)}
              className={
                location.pathname === "/"
                  ? "left_pane__selected_style"
                  : "left_pane__normal_style"
              }
            >
              <MdDashboard
                size={20}
                style={{
                  marginRight: isOpen ? "30px" : "0",
                  color: location.pathname === "/" ? "#FF6175" : "#717579",
                }}
              />
              {isOpen ? "Dashboard" : ""}
              {renderTooltip("Dashboard")}
            </li>
          </Link>
        )}

        {canAccess("aboutus") && (
          <Link to="/about-us">
            <li
              ref={(el) => (iconRefs.current["About us"] = el)}
              onMouseEnter={() => handleMouseEnter("About us", "About us")}
              onMouseLeave={() => setHoveredItem(null)}
              style={{ justifyContent: isOpen ? "flex-start" : "center" }}
              onClick={() => setFliter(1)}
              className={
                location.pathname === "/about-us"
                  ? "left_pane__selected_style"
                  : "left_pane__normal_style"
              }
            >
              <FaComments
                size={20}
                style={{
                  marginRight: isOpen ? "30px" : "0",
                  color: location.pathname === "/about-us" ? "#FF6175" : "#717579",
                }}
              />
              {isOpen ? "About us" : ""}
              {renderTooltip("About us")}
            </li>
          </Link>
        )}

        {canAccess("advertisement") && (
          <Link to="/advertisment">
            <li
              ref={(el) => (iconRefs.current["Advertisement"] = el)}
              onMouseEnter={() =>
                handleMouseEnter("Advertisement", "Advertisement")
              }
              onMouseLeave={() => setHoveredItem(null)}
              style={{ justifyContent: isOpen ? "flex-start" : "center" }}
              onClick={() => setFliter(2)}
              className={
                location.pathname === "/advertisment"
                  ? "left_pane__selected_style"
                  : "left_pane__normal_style"
              }
            >
              <LuMicrowave
                size={20}
                style={{
                  marginRight: isOpen ? "30px" : "0",
                  color: location.pathname === "/advertisment" ? "#FF6175" : "#717579",
                  fill: "#717579",
                  stroke: "#fff",
                }}
              />
              {isOpen ? "Advertisement" : ""}
              {renderTooltip("Advertisement")}
            </li>
          </Link>
        )}

        {canAccess("circular") && (
          <Link to="/circular">
            <li
              ref={(el) => (iconRefs.current["Circular"] = el)}
              onMouseEnter={() => handleMouseEnter("Circular", "Circular")}
              onMouseLeave={() => setHoveredItem(null)}
              style={{ justifyContent: isOpen ? "flex-start" : "center" }}
              onClick={() => setFliter(3)}
              className={
                location.pathname === "/circular"
                  ? "left_pane__selected_style"
                  : "left_pane__normal_style"
              }
            >
              <FaGraduationCap
                size={20}
                style={{
                  marginRight: isOpen ? "30px" : "0",
                  color: location.pathname === "/circular" ? "#FF6175" : "#717579",
                }}
              />
              {isOpen ? "Circular" : ""}
              {renderTooltip("Circular")}
            </li>
          </Link>
        )}

        {canAccess("application") && (
          <Link to="/application">
            <li
              ref={(el) => (iconRefs.current["Application"] = el)}
              onMouseEnter={() => handleMouseEnter("Application", "Application")}
              onMouseLeave={() => setHoveredItem(null)}
              style={{ justifyContent: isOpen ? "flex-start" : "center" }}
              onClick={() => setFliter(4)}
              className={
                location.pathname === "/application"
                  ? "left_pane__selected_style"
                  : "left_pane__normal_style"
              }
            >
              <FaCalendar
                size={20}
                style={{
                  marginRight: isOpen ? "30px" : "0",
                  color: location.pathname === "/application" ? "#FF6175" : "#717579",
                }}
              />
              {isOpen ? "Application" : ""}
              {renderTooltip("Application")}
            </li>
          </Link>
        )}

        {canAccess("student") && (
          <Link to="/students">
            <li
              ref={(el) => (iconRefs.current["Student Management"] = el)}
              onMouseEnter={() => handleMouseEnter("Student Management", "Student Management")}
              onMouseLeave={() => setHoveredItem(null)}
              style={{ justifyContent: isOpen ? "flex-start" : "center" }}
              onClick={() => setFliter(5)}
              className={
                location.pathname === "/students"
                  ? "left_pane__selected_style"
                  : "left_pane__normal_style"
              }
            >
              <FaUsers
                size={20}
                style={{
                  marginRight: isOpen ? "30px" : "0",
                  color: location.pathname === "/students" ? "#FF6175" : "#717579",
                }}
              />
              {isOpen ? "Student Management" : ""}
              {renderTooltip("Student Management")}
            </li>
          </Link>
        )}

        {canAccess("existing_student") && (
          <Link to="/existingstudent">
            <li
              ref={(el) => (iconRefs.current["Existing Student"] = el)}
              onMouseEnter={() => handleMouseEnter("Existing Student", "Existing Student")}
              onMouseLeave={() => setHoveredItem(null)}
              style={{ justifyContent: isOpen ? "flex-start" : "center" }}
              onClick={() => setFliter(11)}
              className={
                location.pathname === "/existingstudent"
                  ? "left_pane__selected_style"
                  : "left_pane__normal_style"
              }
            >
              <FaUserGraduate
                size={20}
                style={{
                  marginRight: isOpen ? "30px" : "0",
                  color: location.pathname === "/existingstudent" ? "#FF6175" : "#717579",
                }}
              />
              {isOpen ? "Existing Student" : ""}
              {renderTooltip("Existing Student")}
            </li>
          </Link>
        )}

        {canAccess("teacher") && (
          <Link to="/teacher">
            <li
              ref={(el) => (iconRefs.current["Teacher"] = el)}
              onMouseEnter={() => handleMouseEnter("Teacher", "Teacher")}
              onMouseLeave={() => setHoveredItem(null)}
              style={{ justifyContent: isOpen ? "flex-start" : "center" }}
              onClick={() => setFliter(6)}
              className={
                location.pathname === "/teacher"
                  ? "left_pane__selected_style"
                  : "left_pane__normal_style"
              }
            >
              <IoMdPerson
                size={20}
                style={{
                  marginRight: isOpen ? "30px" : "0",
                  color: location.pathname === "/teacher" ? "#FF6175" : "#717579",
                }}
              />
              {isOpen ? "Teacher" : ""}
              {renderTooltip("Teacher")}
            </li>
          </Link>
        )}

        {canAccess("fee") && (
          <li
            ref={(el) => (iconRefs.current["Fees Management"] = el)}
            onMouseEnter={() =>
              handleMouseEnter("Fees Management", "Fees Management")
            }
            onMouseLeave={() => setHoveredItem(null)}
            onClick={() => {
              setFliter(9);
              setSubmenu(!submenu);
            }}
            style={{
              justifyContent: isOpen ? "flex-start" : "center",
            }}
            className={
              location.pathname === "/fee_report" ||
              location.pathname === "/fee_setup"
                ? "left_pane__selected_style"
                : "left_pane__normal_style"
            }
          >
            <RiBarChart2Fill
              size={20}
              style={{
                marginRight: isOpen ? "30px" : "0",
                color:
                  location.pathname === "/fee_report" ||
                  location.pathname === "/fee_setup"
                    ? "#FF6175"
                    : "#717579",
              }}
            />
            {isOpen ? "Fees Management" : ""}
            {renderTooltip("Fees Management")}
            {isOpen && (
              <svg
                width="30"
                height="6"
                viewBox="0 0 12 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 -5.24537e-07L6 6L12 0"
                  fill={
                    location.pathname === "/fee_report" ||
                    location.pathname === "/fee_setup"
                      ? "#FF6175"
                      : "#717579"
                  }
                />
              </svg>
            )}
          </li>
        )}

        {canAccess("fee") && (
          <Link to="/fee_report">
            <li
              ref={(el) => (iconRefs.current["Fee Report"] = el)}
              onMouseEnter={() => handleMouseEnter("Fee Report", "Fee Report")}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={() => setFliter(12)}
              style={{
                padding: isOpen ? "10px 24px 10px 83px" : "20px 30px",
              }}
              className={
                submenu
                  ? location.pathname === "/fee_report"
                    ? "left_pane__selected_style submenu_visible"
                    : "left_pane__normal_style submenu_visible"
                  : "submenu_invisible"
              }
            >
              {isOpen ? (
                "Fee Report"
              ) : (
                <FaChartColumn
                  size={20}
                  style={{
                    color: location.pathname === "/fee_report" ? "#FF6175" : "#717579",
                  }}
                />
              )}
              {renderTooltip("Fee Report")}
            </li>
          </Link>
        )}

        {canAccess("fee") && (
          <Link to="/fee_setup">
            <li
              ref={(el) => (iconRefs.current["Fee Setup"] = el)}
              onMouseEnter={() => handleMouseEnter("Fee Setup", "Fee Setup")}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={() => setFliter(13)}
              style={{
                padding: isOpen ? "10px 24px 10px 83px" : "20px 30px",
              }}
              className={
                submenu
                  ? location.pathname === "/fee_setup"
                    ? "left_pane__selected_style submenu_visible"
                    : "left_pane__normal_style submenu_visible"
                  : "submenu_invisible"
              }
            >
              {isOpen ? (
                "Fee Setup"
              ) : (
                <MdTune
                  size={20}
                  style={{
                    color: location.pathname === "/fee_setup" ? "#FF6175" : "#717579",
                  }}
                />
              )}
              {renderTooltip("Fee Setup")}
            </li>
          </Link>
        )}

        {canAccess("new_admission") && (
          <Link to="/new_admission">
            <li
              ref={(el) => (iconRefs.current["New Admission"] = el)}
              onMouseEnter={() =>
                handleMouseEnter("New Admission", "New Admission")
              }
              onMouseLeave={() => setHoveredItem(null)}
              style={{ justifyContent: isOpen ? "flex-start" : "center" }}
              onClick={() => setFliter(10)}
              className={
                location.pathname === "/new_admission"
                  ? "left_pane__selected_style"
                  : "left_pane__normal_style"
              }
            >
              <MdAddBox
                size={20}
                style={{
                  marginRight: isOpen ? "30px" : "0",
                  color: location.pathname === "/new_admission" ? "#FF6175" : "#717579",
                }}
              />
              {isOpen ? "New Admission" : ""}
              {renderTooltip("New Admission")}
            </li>
          </Link>
        )}

        {canAccess("role") && (
          <li
            ref={(el) => (iconRefs.current["Roles"] = el)}
            onMouseEnter={() => handleMouseEnter("Roles", "Roles")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={() => {
              setFliter(7);
              setRolesSubmenu(!rolesSubmenu); // Toggle Roles submenu
            }}
            style={{ justifyContent: isOpen ? "flex-start" : "center" }}
            className={
              location.pathname === "/add_user" || location.pathname === "/add_role"
                ? "left_pane__selected_style"
                : "left_pane__normal_style"
            }
          >
            <MdGroup
              size={20}
              style={{
                marginRight: isOpen ? "30px" : "0",
                color:
                  location.pathname === "/add_user" || location.pathname === "/add_role"
                    ? "#FF6175"
                    : "#717579",
              }}
            />
            {isOpen ? "Roles" : ""}
            {renderTooltip("Roles")}
            {isOpen && (
              <svg
                width="30"
                height="6"
                viewBox="0 0 12 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 -5.24537e-07L6 6L12 0"
                  fill={
                    location.pathname === "/add_user" || location.pathname === "/add_role"
                      ? "#FF6175"
                      : "#717579"
                  }
                />
              </svg>
            )}
          </li>
        )}

        {canAccess("role") && (
          <Link to="/add_user">
            <li
              ref={(el) => (iconRefs.current["Add User"] = el)}
              onMouseEnter={() => handleMouseEnter("Add User", "Add User")}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={() => setFliter(14)}
              style={{
                padding: isOpen ? "10px 24px 10px 83px" : "20px 30px",
              }}
              className={
                rolesSubmenu
                  ? location.pathname === "/add_user"
                    ? "left_pane__selected_style submenu_visible"
                    : "left_pane__normal_style submenu_visible"
                  : "submenu_invisible"
              }
            >
              {isOpen ? (
                "Add User"
              ) : (
                <TiUserAdd
                  size={20}
                  style={{
                    color: location.pathname === "/add_user" ? "#FF6175" : "#717579",
                  }}
                />
              )}
              {renderTooltip("Add User")}
            </li>
          </Link>
        )}

        {canAccess("role") && (
          <Link to="/add_role">
            <li
              ref={(el) => (iconRefs.current["Add Role"] = el)}
              onMouseEnter={() => handleMouseEnter("Add Role", "Add Role")}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={() => setFliter(15)}
              style={{
                padding: isOpen ? "10px 24px 10px 83px" : "20px 30px",
              }}
              className={
                rolesSubmenu
                  ? location.pathname === "/add_role"
                    ? "left_pane__selected_style submenu_visible"
                    : "left_pane__normal_style submenu_visible"
                  : "submenu_invisible"
              }
            >
              {isOpen ? (
                "Add Role"
              ) : (
                <MdOutlineAddBox
                  size={20}
                  style={{
                    color: location.pathname === "/add_role" ? "#FF6175" : "#717579",
                  }}
                />
              )}
              {renderTooltip("Add Role")}
            </li>
          </Link>
        )}

        {/* <li
          ref={(el) => (iconRefs.current["Settings"] = el)}
          onMouseEnter={() => handleMouseEnter("Settings", "Settings")}
          onMouseLeave={() => setHoveredItem(null)}
          onClick={() => setFliter(8)}
          style={{ justifyContent: isOpen ? "flex-start" : "center" }}
          className={
            filter === 8
              ? "left_pane__selected_style"
              : "left_pane__normal_style"
          }
        >
          <IoSettingsSharp
            size={20}
            style={{
              marginRight: isOpen ? "30px" : "0",
              color: filter === 8 ? "#FF6175" : "#717579",
            }}
          />
          {isOpen ? "Settings" : ""}
          {renderTooltip("Settings")}
        </li> */}
      </ul>
    </div>
  );
};

export default LeftPane;